import React, { Component } from 'react';
import {connect} from "react-redux";
import * as actionTypesModal from './redux/action/modalAction';

export default function (ComposedComponent) {
  class NetworkDetector extends Component {
    state = {
      isDisconnected: false
    }

    componentDidMount() {
      this.handleConnectionChange();
      window.addEventListener('online', this.handleConnectionChange);
      window.addEventListener('offline', this.handleConnectionChange);
    }

    componentWillUnmount() {
      window.removeEventListener('online', this.handleConnectionChange);
      window.removeEventListener('offline', this.handleConnectionChange);
    }


    handleConnectionChange = () => {
      const condition = navigator.onLine ? 'online' : 'offline';
      if (condition === 'online') {
        const webPing = setInterval(
          () => {
            fetch('//google.com', {
              mode: 'no-cors',
              })
            .then(() => {
              this.setState({ isDisconnected: false }, () => {
                return clearInterval(webPing)
              });
            }).catch(() => this.setState({ isDisconnected: true }) )
          }, 2000);
        return;
      }

      return this.setState({ isDisconnected: true });
    }

    showModal = (modal) => {
      modal({
        title: 'KENDALA JARINGAN',
        body: 'JARINGAN TIDAK STABIL. SILAHKAN COBA KEMBALI',
        reload: true
      })
    }

    hideModal = (modal) => {
      modal()
    }

    render() {
      const { isDisconnected } = this.state;
      return (
        <div>
          { isDisconnected && this.showModal(this.props.showModalAction)}
          <ComposedComponent {...this.props} />
        </div>
      );
    }
  }

  const mapDispatchToProps = (dispatch) => {
    return {
        showModalAction: (object) => dispatch(actionTypesModal.showModalAction(object)),
        hideModalAction: () => dispatch(actionTypesModal.hideModalAction()),
    }
  }

  return connect(null, mapDispatchToProps)(NetworkDetector);
}
